/** Design-system typography showcase � mirrors Large / Small screen spec tables (from sf-react-app) */
const DS_TYPE_LARGE_SCREEN_ROWS = [
  {
    tag: 'T1',
    variant: 't1',
    label: 'Heading Semi bold',
    size: '32px',
    weight: 'Semi bold',
    lh: 'Auto',
    letter: '-0.5%',
    para: '0px',
  },
  {
    tag: 'T2',
    variant: 't2',
    label: 'Body Semi bold',
    size: '24px',
    weight: 'Semi bold',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T3',
    variant: 't3',
    label: 'Body Medium',
    size: '24px',
    weight: 'Medium',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T4',
    variant: 't4',
    label: 'Body Semi bold',
    size: '22px',
    weight: 'Semi bold',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T5',
    variant: 't5',
    label: 'Body Medium',
    size: '22px',
    weight: 'Medium',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T6',
    variant: 't6',
    label: 'Body Semi bold',
    size: '20px',
    weight: 'Semi bold',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T7',
    variant: 't7',
    label: 'Body Medium',
    size: '20px',
    weight: 'Medium',
    lh: '30px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T8',
    variant: 't8',
    label: 'Heading Semi bold',
    size: '18px',
    weight: 'Semi bold',
    lh: '30px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T9',
    variant: 't9',
    label: 'Heading Semi bold',
    size: '18px',
    weight: 'Semi bold',
    lh: '22px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T10',
    variant: 't10',
    label: 'Sub Heading Medium',
    size: '17px',
    weight: 'Medium',
    lh: 'Auto',
    letter: '-0.5%',
    para: '0px',
  },
  {
    tag: 'T11',
    variant: 't11',
    label: 'Body Semi bold',
    size: '16px',
    weight: 'Semi bold',
    lh: '20px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T12',
    variant: 't12',
    label: 'Body Medium',
    size: '16px',
    weight: 'Medium',
    lh: '20px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T13',
    variant: 't13',
    label: 'Body Semi bold',
    size: '14px',
    weight: 'Semi bold',
    lh: '20px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T14',
    variant: 't14',
    label: 'Body Medium',
    size: '14px',
    weight: 'Medium',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T15',
    variant: 't15',
    label: 'Body Medium',
    size: '14px',
    weight: 'Medium',
    lh: '20px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T16',
    variant: 't16',
    label: 'Body Regular',
    size: '14px',
    weight: 'Regular',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T17',
    variant: 't17',
    label: 'Body Regular',
    size: '14px',
    weight: 'Regular',
    lh: '20px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T18',
    variant: 't18',
    label: 'Body Medium',
    size: '12px',
    weight: 'Medium',
    lh: '18px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T19',
    variant: 't19',
    label: 'Body Regular',
    size: '12px',
    weight: 'Regular',
    lh: 'Auto',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T20',
    variant: 't20',
    label: 'Body Regular',
    size: '12px',
    weight: 'Regular',
    lh: '18px',
    letter: '0%',
    para: '0px',
  },
  {
    tag: 'T21',
    variant: 't21',
    label: 'Body Italic',
    size: '12px',
    weight: 'Italic',
    lh: '18px',
    letter: '0%',
    para: '0px',
  },
];

const DS_TYPE_SMALL_SCREEN_ROWS = [
  {
    name: 'DisplayXLarge',
    variant: 'displayXLarge',
    sample: 'DisplayXLarge',
    fs: '40px',
    fsTok: 'font-size-1100',
    lh: '48px',
    lhTok: 'line-height-1100',
    weight: '400, 500, 600',
    letter: '-1% (400, 500) · 0% (600)',
    letterTok: 'letter-spacing-50 / letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'DisplayLarge',
    variant: 'displayLarge',
    sample: 'DisplayLarge',
    fs: '38px',
    fsTok: 'font-size-1000',
    lh: '46px',
    lhTok: 'line-height-1000',
    weight: '400, 500, 600',
    letter: '-1% (400, 500) · 0% (600)',
    letterTok: 'letter-spacing-50 / letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'DisplayMedium',
    variant: 'displayMedium',
    sample: 'DisplayMedium',
    fs: '36px',
    fsTok: 'font-size-900',
    lh: '42px',
    lhTok: 'line-height-900',
    weight: '400, 500, 600',
    letter: '-1% (400, 500) · 0% (600)',
    letterTok: 'letter-spacing-50 / letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'DisplaySmall',
    variant: 'displaySmall',
    sample: 'DisplaySmall',
    fs: '34px',
    fsTok: 'font-size-800',
    lh: '40px',
    lhTok: 'line-height-800',
    weight: '400, 500, 600',
    letter: '-1% (400, 500) · 0% (600)',
    letterTok: 'letter-spacing-50 / letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'Heading2XLarge',
    variant: 'heading2XLarge',
    sample: 'Heading2XLarge',
    fs: '32px',
    fsTok: 'font-size-700',
    lh: '38px',
    lhTok: 'line-height-700',
    weight: '400, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'HeadingXLarge',
    variant: 'headingXLarge',
    sample: 'HeadingXLarge',
    fs: '24px',
    fsTok: 'font-size-600',
    lh: '32px',
    lhTok: 'line-height-600',
    weight: '400, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'HeadingLarge',
    variant: 'headingLarge',
    sample: 'HeadingLarge',
    fs: '20px',
    fsTok: 'font-size-500',
    lh: '26px',
    lhTok: 'line-height-500',
    weight: '400, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'HeadingMedium',
    variant: 'headingMedium',
    sample: 'HeadingMedium',
    fs: '18px',
    fsTok: 'font-size-400',
    lh: '24px',
    lhTok: 'line-height-400',
    weight: '400, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'HeadingSmall',
    variant: 'headingSmall',
    sample: 'HeadingSmall',
    fs: '16px',
    fsTok: 'font-size-300',
    lh: '22px',
    lhTok: 'line-height-300',
    weight: '400, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'BodyLarge',
    variant: 'bodyLarge',
    sample: 'BodyLarge',
    fs: '16px',
    fsTok: 'font-size-200',
    lh: '24px',
    lhTok: 'line-height-200',
    weight: '400, 500, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '12px',
    paraTok: 'paragraph-spacing-400',
  },
  {
    name: 'BodyMedium',
    variant: 'bodyMedium',
    sample: 'BodyMedium',
    fs: '14px',
    fsTok: 'font-size-100',
    lh: '20px',
    lhTok: 'line-height-100',
    weight: '400, 500, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '11px',
    paraTok: 'paragraph-spacing-300',
  },
  {
    name: 'BodySmall',
    variant: 'bodySmall',
    sample: 'BodySmall',
    fs: '12px',
    fsTok: 'font-size-50',
    lh: '18px',
    lhTok: 'line-height-75',
    weight: '400, 500, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '10px',
    paraTok: 'paragraph-spacing-200',
  },
  {
    name: 'BodyXSmall',
    variant: 'bodyExtraSmall',
    sample: 'BodyXSmall',
    fs: '10px',
    fsTok: 'font-size-10',
    lh: '14px',
    lhTok: 'line-height-25',
    weight: '400, 500, 600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '8px',
    paraTok: 'paragraph-spacing-100',
  },
  {
    name: 'CaptionMedium',
    variant: 'captionMedium',
    sample: 'CaptionMedium',
    fs: '11px',
    fsTok: 'font-size-25',
    lh: '16px',
    lhTok: 'line-height-50',
    weight: '600',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'CodeMedium',
    variant: 'codeMedium',
    sample: 'CodeMedium',
    fs: '12px',
    fsTok: 'font-size-50',
    lh: '18px',
    lhTok: 'line-height-75',
    weight: '400, 700',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
  {
    name: 'CodeSmall',
    variant: 'codeSmall',
    sample: 'CodeSmall',
    fs: '10px',
    fsTok: 'font-size-10',
    lh: '14px',
    lhTok: 'line-height-25',
    weight: '400, 700',
    letter: '0%',
    letterTok: 'letter-spacing-100',
    para: '0px',
    paraTok: 'paragraph-spacing-00',
  },
];
export { DS_TYPE_LARGE_SCREEN_ROWS, DS_TYPE_SMALL_SCREEN_ROWS };
